import StyledLink from '../StyledLink'
import {
  ADD,
  SPACE_API_ACCESS
} from '../routes'
import type { Props } from '../types'

const LinkToAddSpaceApiAccess = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SPACE_API_ACCESS + '/' + ADD}
  >
    {children}
  </StyledLink>

export default LinkToAddSpaceApiAccess
